import React from 'react';

/**
 * @param {Function} onSearchChange Callback
 * @param {Function} onSearchKeyUp Callback
 * @param {String} searchText
 * @param {Boolean} hasSearchButton
 * @param {Boolean} hasAutoFocus
 * @description A SFC component that renders a searchbox
 */
const GenericSearchBox = ({ onSearchChange, onSearchKeyUp, searchText, hasSearchButton, hasAutoFocus }) => {

    let groupClass = 'form-group';
    let searchButton = null;

    if (hasSearchButton) {
        groupClass = 'input-group';
        searchButton = (
            <span className="input-group-btn">
                <button className="btn btn-default">
                    <span className="glyphicon glyphicon-search" />
                </button>
            </span>
        );
    }

    return (
        <div className={groupClass}>
            <input 
                className="form-control"
                placeholder="Search"
                onInput={onSearchChange} 
                onKeyUp={onSearchKeyUp} 
                defaultValue={searchText}
                /* eslint-disable-next-line jsx-a11y/no-autofocus */
                autoFocus={hasAutoFocus}
            />
            {searchButton}
        </div>
    );
};

export default GenericSearchBox;
